import classNames from 'classnames'
import { bool, node, string } from 'prop-types'

import './RoundBadge.scss'

const RoundBadge = props => {
  const {
    size,
    color,
    children,
    whiteBorder,
    ellipse,
    'data-clientside-hook': dataClientsideHook,
    className,
  } = props

  const roundBadgeClassName = classNames(
    'a-RoundBadge',
    {
      [`a-RoundBadge--${size}`]: size,
      [`a-RoundBadge--${color}`]: color,
      'a-RoundBadge--white-border': whiteBorder,
      'a-RoundBadge--ellipse': ellipse,
    },
    className
  )

  if (children) {
    return (
      <span
        className={roundBadgeClassName}
        data-clientside-hook={dataClientsideHook}
      >
        {children}
      </span>
    )
  }
  return null
}

RoundBadge.propTypes = {
  children: node,
  size: string,
  color: string,
  whiteBorder: bool,
  className: string,
  ellipse: bool,
  'data-clientside-hook': string,
}

RoundBadge.defaultProps = {
  children: null,
  size: null,
  color: null,
  whiteBorder: false,
  className: null,
  ellipse: false,
  'data-clientside-hook': null,
}

export default RoundBadge
